import "material-icons/iconfont/material-icons.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css"; // Icons
import { PrimeReactProvider } from "primereact/api";
import "primereact/resources/primereact.min.css"; // Core CSS
import "primereact/resources/themes/nova/theme.css"; // Theme
import React from "react";
import ReactDOM from "react-dom/client";
import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import App from "./App";
import "./assets/css/variables.css";
import { ToastProvider } from "./common_nextgen/hooks/ToastContext";
import {
  PRICE_SCHEDULE_MODES,
  ROUTE_PATHS,
} from "./common_nextgen/utils/Constants";
import CopyPriceSchedule from "./components/PriceSchedule/CopyPriceSchedule";
import "./index.css";
import BenefitMaxDrugStatusSchedule from "./pages/BenefitMaxDrugStatusSchedule/BenefitMaxDrugStatusSchedule";
import DrugStatusSchedule from "./pages/BenefitMaxDrugStatusSchedule/DrugStatusSchedule";
import CopyDeductibleSchedule from "./pages/DeductibleSchedule/CopyDeductibleSchedule";
import DeductibleSchedule from "./pages/DeductibleSchedule/DeductibleSchedule";
import DeductibleScheduleForm from "./pages/DeductibleSchedule/DeductibleScheduleForm";
import DeductibleScheduleNote from "./pages/DeductibleSchedule/DeductibleScheduleNote";
import DeductibleScheduleStepDetailExtensionForm from "./pages/DeductibleSchedule/DeductibleScheduleStepDetailExtensionForm";
import DeductibleScheduleSteps from "./pages/DeductibleSchedule/DeductibleScheduleSteps";
import DeductibleScheduleStepsForm from "./pages/DeductibleSchedule/DeductibleScheduleStepsForm";
import DeductiblePatientPayScheduleForm from "./pages/DeductibleSchedule/DeductiblePatientPayScheduleForm";
import DeductibleScheduleStepPatientPaySchedules from "./pages/DeductibleSchedule/DeductibleScheduleStepPatientPaySchedules";
import OopPatientPaySchedulesForm from "./pages/OutofPocketSchedule/OopPatientPaySchedulesForm";
import OutOfPocketForm from "./pages/OutofPocketSchedule/OutofPocketForm";
import OutOfPocketMaxDetailForm from "./pages/OutofPocketSchedule/OutofPocketMaxDetailForm";
import OutOfPocketMaxSchedule from "./pages/OutofPocketSchedule/OutofPocketMaxSchedule";
import OutOfPocketMaxScheduleSteps from "./pages/OutofPocketSchedule/OutOfPocketMaxScheduleSteps";
import OutOfPocketMaxScheduleStepsDetailExt from "./pages/OutofPocketSchedule/OutOfPocketMaxScheduleStepsDetailExt";
import OutOfPocketMaxScheduleStepsDetailExtForm from "./pages/OutofPocketSchedule/OutOfPocketMaxScheduleStepsDetailExtForm";
import OutofPocketPatientPaySchedule from "./pages/OutofPocketSchedule/OutofPocketPatientPaySchedule";
import OutOfPocketSubStep from "./pages/OutofPocketSchedule/OutOfPocketSubStep";
import OutOfPocketSubStepForm from "./pages/OutofPocketSchedule/OutOfPocketSubStepForm";
import PriceSchedule from "./pages/PriceSchedule/PriceSchedule";
import PriceScheduleForm from "./pages/PriceSchedule/PriceScheduleForm";
import PriceScheduleNote from "./pages/PriceSchedule/PriceScheduleNote";
import reportWebVitals from "./reportWebVitals";

import BenefitMaxDrugStatusScheduleForm from "./pages/BenefitMaxDrugStatusSchedule/BenefitMaxDrugStatusScheduleForm";
import CopyOutOfPocketMaxSchedule from "./pages/OutofPocketSchedule/CopyOutOfPocketMaxSchedule";
import OutOfPocketMaxScheduleNote from "./pages/OutofPocketSchedule/OutOfPocketMaxScheduleNote";

import { AuthProvider } from "./common_nextgen/hooks/AuthContext";
import { RBACProvider } from "./common_nextgen/hooks/RBACContext";
import { LoaderProvider } from "./common_nextgen/hooks/LoaderContext";
import AccumulationCodeList from "./pages/AccumulationCodeList/AccumulationCodeList";
import CopyBenefitMaxDrugStatusSchedule from "./pages/BenefitMaxDrugStatusSchedule/CopyBenefitMaxDrugStatusSchedule";
import DrugStatusForm from "./pages/BenefitMaxDrugStatusSchedule/DrugStatusScheduleForm";
import AlternateCopayPscOverrideForm from "./pages/BenefitMaxSchedule/AlternateCopayOverrideForm";
import AlternateCopayPSCOverrides from "./pages/BenefitMaxSchedule/AlternateCopayPSCOverrides";
import BenefitMaximumStepAlternateCopaysForm from "./pages/BenefitMaxSchedule/BenefitAltCopayForm";
import BenefitMaxSchedule from "./pages/BenefitMaxSchedule/BenefitMaxSchedule";
import BenefitMaxScheduleForm from "./pages/BenefitMaxSchedule/BenefitMaxScheduleForm";
import BenefitMaxScheduleNote from "./pages/BenefitMaxSchedule/BenefitMaxScheduleNote";
import BenefitMaxScheduleSteps from "./pages/BenefitMaxSchedule/BenefitMaxStepSchedule";
import BenefitMaxStepScheduleForm from "./pages/BenefitMaxSchedule/BenefitMaxStepScheduleForm";
import CopyBenefitMaxSchedule from "./pages/BenefitMaxSchedule/CopyBenefitMaxSchedule";

import AccumulationCode from "./pages/Accumalation/AccumulationCode";
import AccumulationCodeForm from "./pages/Accumalation/AccumulationCodeForm";
import AccumulationCodeListAl2 from "./pages/AccumulationCodeList/AccumulationCodeListAl2";
import AccumulationCodeListForm from "./pages/AccumulationCodeList/AccumulationCodeListForm";

import AccumulatorOverrideSchedule from "./pages/AcumulatorOverrideSchedule/AccumulatorOverrideSchedule";
import AccumulatorOverrideScheduleCriteria from "./pages/AcumulatorOverrideSchedule/AccumulatorOverrideScheduleCriteria";
import AccumulatorOverrideScheduleCriteriaForm from "./pages/AcumulatorOverrideSchedule/AccumulatorOverrideScheduleCriteriaForm";
import AccumulatorOverrideScheduleForm from "./pages/AcumulatorOverrideSchedule/AccumulatorOverrideScheduleForm";
import AccumulatorOverrideStateSchedule from "./pages/AcumulatorOverrideSchedule/AccumulatorOverrideStateSchedule";
import AdjustmentReasonCodeList from "./pages/AdjustmentReasonCodeList/AdjustmentReasonCodeList";
import AdjustmentReasonCodeListForm from "./pages/AdjustmentReasonCodeList/AdjustmentReasonCodeListForm";
import CodesInAdjustmentReasonCodeList from "./pages/AdjustmentReasonCodeList/CodesInAdjustmentReasonCodeList";
import AdjustmentReasonCode from "./pages/AdjustmentReasonCodes/AdjustmentReasonCode";
import AdjustmentReasonForm from "./pages/AdjustmentReasonCodes/AdjustmentReasonForm";
import StandardTroopSchedule from "./pages/MedicareStandardTroopSchedule/StandardTroopSchedule";
import StandardTrOOPScheduleStepDetailForm from "./pages/MedicareStandardTroopSchedule/StandardTrOOPScheduleStepDetailForm";
import StandardTroopScheduleSteps from "./pages/MedicareStandardTroopSchedule/StandardTroopScheduleSteps";
import PlanOverride from "./pages/LookUps/PlanOverride/PlanOverride";
import AccumulatorOverrideStateScheduleForm from "./pages/AcumulatorOverrideSchedule/AccumulatorOverrideStateScheduleForm";
import CopyMergeAccumulationCodeList from "./pages/AccumulationCodeList/CopyMergeAccumulationCodeList";

import TrOOPSchedule from "./pages/TroopSchedule/TrOOPSchedule";
import TroopScheduleForm from "./pages/TroopSchedule/TrOOPScheduleForm";
import DosageFormList from "./pages/LookUps/DosageFormList/DosageFormList";
import DosageForm from "./pages/LookUps/DosageForm/DosageForm";
import PackagingCodesList from "./pages/LookUps/PackagingCodesList/PackagingCodesList";

import CopyMergeAdjustmentReasonCodeList from "./pages/AdjustmentReasonCodeList/CopyMergeAdjustmentReasonCodeList";
import LicsSchedule from "./pages/MedicareLicsSchedule/LicsSchedule";
import LicsScheduleDetail from "./pages/MedicareLicsSchedule/LicsScheduleDetail";
import TroopScheduleStep from "./pages/TroopSchedule/TroopScheduleStep";
import TroopScheduleStepForm from "./pages/TroopSchedule/TroopScheduleStepForm";
import TrOOPScheduleStepMessage from "./pages/TroopSchedule/TrOOPScheduleStepMessage";
import TroopScheduleStepMessageForm from "./pages/TroopSchedule/TrOOPScheduleStepMessageForm";
import CopyTroopSchedule from "./pages/TroopSchedule/CopyTroopSchedule";
import CopyAccumulatorOverrideSchedule from "./pages/AcumulatorOverrideSchedule/CopyAccumulatorOverrideSchedule";
import AccumulatorOverrideScheduleNote from "./pages/AcumulatorOverrideSchedule/AccumulatorOverrideScheduleNote";
import { ModalProvider } from "./common_nextgen/hooks/ModalContext";
import ModalComponent from "./common_nextgen/common_components/LookupModal/ModalComponent";
import ThirdPartyException from "./pages/LookUps/ThirdPartyException/ThirdPartyException";
import RouteOfAdministration from "./pages/LookUps/RouteOfAdmin/RouteOfAdministration";
import RouteOfAdministrationList from "./pages/LookUps/RouteOfAdminList/RouteOfAdministrationList";
import DeaClassList from "./pages/LookUps/DeaClassList/DeaClassList";
import CsrFederalLevel from "./pages/LookUps/CsrFederalLevel/CsrFederalLevel";
import GpiMscList from "./pages/LookUps/GpiMscList/GpiMscList";
import NdcList from "./pages/LookUps/NdcList/NdcList";
import CsrStateLevel from "./pages/LookUps/CsrStateLevel/CsrStateLevel";
import CostSource from "./pages/LookUps/CostSource/CostSource";
import CostType from "./pages/LookUps/CostType/CostType";
import MultiSourceCodeList from "./pages/LookUps/MultiSourceCodeList/MultiSourceCodeList";
import StateList from "./pages/LookUps/StateList/StateList";
import MacList from "./pages/LookUps/MacList/MacList";
import CopayScheduleStep from "./pages/LookUps/CopayScheduleStep/CopayScheduleStep";
import SelectMessage from "./pages/LookUps/SelectMessage/SelectMessage";

const root = ReactDOM.createRoot(document.getElementById("root"));
const {
  ADD_PRICE_SCHEDULE,
  EDIT_PRICE_SCHEDULE,
  DISPLAY_PRICE_SCHEDULE,
  COPY_PRICE_SCHEDULE,
  PRICE_SCHEDULE,
  PRICE_SCHEDULE_NOTE,

  DEDUCTIBLE_SCHEDULE_STEPS,
  DEDUCTIBLE_SCHEDULE,
  ADD_DEDUCTIBLE_SCHEDULE_STEP,
  DISPLAY_DEDUCTIBLE_SCHEDULE_STEP,
  EDIT_DEDUCTIBLE_SCHEDULE_STEP,
  ADD_OUT_OF_POCKET_MAX_SCHEDULE,
  EDIT_OUT_OF_POCKET_MAX_SCHEDULE,
  DISPLAY_OUT_OF_POCKET_MAX_SCHEDULE,
  OUT_OF_POCKET_MAX_SCHEDULE,
  OUT_OF_POCKET_MAX_SCHEDULE_STEPS,
  OUT_OF_POCKET_MAX_SCHEDULE_STEPS_DETAILS_EXT,
  ADD_OUT_OF_POCKET_MAX_SCHEDULE_DETAIL,
  EDIT_OUT_OF_POCKET_MAX_SCHEDULE_DETAIL,
  DISPLAY_OUT_OF_POCKET_MAX_SCHEDULE_DETAIL,
  ADD_OUT_OF_POCKET_MAX_SCHEDULE_STEPS_DETAILS_EXT,
  EDIT_OUT_OF_POCKET_MAX_SCHEDULE_STEPS_DETAILS_EXT,
  DISPLAY_OUT_OF_POCKET_MAX_SCHEDULE_STEPS_DETAILS_EXT,
  DEDUCTIBLE_SCHEDULE_NOTE,
  COPY_DEDUCTIBLE_SCHEDULE,
  ADD_DEDUCTIBLE_SCHEDULE,
  EDIT_DEDUCTIBLE_SCHEDULE,
  DISPLAY_DEDUCTIBLE_SCHEDULE,
  DEDUCTIBLE_SCHEDULE_STEP_DETAIL_EXTENSION,
  COPY_OUT_OF_POCKET_MAX_SCHEDULE,
  OUT_OF_POCKET_PATIENT_PAY_SCHEDULE,
  OUT_OF_POCKET_MAX_SCHEDULE_NOTE,
  BENEFIT_MAX_DRUG_STATUS_SCHEDULE,
  ADD_OUT_OF_POCKET_PATIENT_PAY_SCHEDULE,
  EDIT_OUT_OF_POCKET_PATIENT_PAY_SCHEDULE,
  DISPLAY_OUT_OF_POCKET_PATIENT_PAY_SCHEDULE,
  OUT_OF_POCKET_MAX_SCHEDULE_SUB_STEPS,
  PATIENT_PAY_SCHEDULES,
  ADD_DEDUCTIBLE_PATIENT_PAY_SCHEDULE,
  EDIT_DEDUCTIBLE_PATIENT_PAY_SCHEDULE,
  DISPLAY_DEDUCTIBLE_PATIENT_PAY_SCHEDULE,
  ADD_OUT_OF_POCKET_MAX_SCHEDULE_SUB_STEPS,
  EDIT_OUT_OF_POCKET_MAX_SCHEDULE_SUB_STEPS,
  DISPLAY_OUT_OF_POCKET_MAX_SCHEDULE_SUB_STEPS,
  ADD_BENEFIT_MAX_DRUG_STATUS_SCHEDULE,
  EDIT_BENEFIT_MAX_DRUG_STATUS_SCHEDULE,
  DISPLAY_BENEFIT_MAX_DRUG_STATUS_SCHEDULE,

  BENEFIT_MAX_SCHEDULE_ADD,
  BENEFIT_MAX_SCHEDULE_DISPLAY,
  BENEFIT_MAX_SCHEDULE_EDIT,
  COPY_BENEFIT_MAX_SCHEDULE,
  BENEFIT_MAX_SCHEDULE_NOTE,

  BENEFIT_MAX_STEP_SCHEDULE_SEARCH,
  BENEFIT_MAX_STEP_SCHEDULE_ADD,
  BENEFIT_MAX_STEP_SCHEDULE_DISPLAY,
  BENEFIT_MAX_STEP_SCHEDULE_EDIT,

  BENEFIT_ALT_COPAY_FORM_EDIT,
  BENEFIT_MAX_SCHEDULE,
  ALTERNATE_COPPAY_OVERRIDE,

  ALTERNATE_COPAY_OVERRIDE_ADD,
  ALTERNATE_COPAY_OVERRIDE_DISPLAY,
  ALTERNATE_COPAY_OVERRIDE_EDIT,

  DRUG_STATUS_SCHEDULE,
  ADD_DRUG_STATUS_SCHEDULE,
  EDIT_DRUG_STATUS_SCHEDULE,
  DISPLAY_DRUG_STATUS_SCHEDULE,
  ACCUMULATION_CODE,
  ACCUMULATION_CODE_EXTERNAL,
  COPY_BENEFIT_MAX_DRUG_STATUS_SCHEDULE,

  ACCUMULATION_CODE_ADD,
  ACCUMULATION_CODE_DISPLAY,
  ACCUMULATION_CODE_EDIT,

  ADD_ACCUMULATOR_OVERRIDE_SCHEDULE,
  EDIT_ACCUMULATOR_OVERRIDE_SCHEDULE,
  DISPLAY_ACCUMULATOR_OVERRIDE_SCHEDULE,
  ADD_ACCUMULATOR_OVERRIDE_SCHEDULE_CRITERIA,
  EDIT_ACCUMULATOR_OVERRIDE_SCHEDULE_CRITRIA,
  DISPLAY_ACCUMULATOR_OVERRIDE_SCHEDULE_CRITRIA,
  ACCUMULATION_CODE_LIST_ADD,
  ACCUMULATION_CODE_LIST_EDIT,
  ACCUMULATION_CODE_LIST_DISPLAY,
  ACCUMULATION_CODE_LIST,
  ACCUMULATION_CODE_LIST_CODES,
  ADJUSTMENT_REASON_CODE_LIST,
  ADJUSTMENT_REASON_CODE_LIST_ADD,
  ADJUSTMENT_REASON_CODE_LIST_EDIT,
  ADJUSTMENT_REASON_CODE_LIST_DISPLAY,
  CODES_IN_ADJUSTMENT_REASON_CODE_LIST,
  ADJUSTMENT_REASON_CODE,
  ADJUSTMENT_REASON_CODE_ADD,
  ADJUSTMENT_REASON_CODE_EDIT,
  ADJUSTMENT_REASON_CODE_DISPLAY,
  ACCUMULATOR_OVERRIDE_SCHEDULE,
  ACCUMULATOR_OVERRIDE_SCHEDULE_CRITERIA,
  PLAN_OVERRIDE,
  ACCUMULATOR_OVERRIDE_SCHEDULE_STATE,
  COPY_ACCUMULATION_CODE_LIST,

  TROOP_SCHEDULE,
  TROOP_SCHEDULE_ADD,
  TROOP_SCHEDULE_DISPLAY,
  TROOP_SCHEDULE_EDIT,
  MEDICARE_STANDARD_TROOP_SCHEDULE_STEPS,
  MEDICARE_STANDARD_TROOP_SCHEDULE,
  MEDICARE_STANDARD_TROOP_SCHEDULE_STEPS_DETAIL,
  TROOP_SCHEDULE_STEP,
  TROOP_SCHEDULE_STEP_ADD,
  TROOP_SCHEDULE_STEP_DISPLAY,
  TROOP_SCHEDULE_STEP_EDIT,
  TROOP_SCHEDULE_STEP_MESSAGE,
  TROOP_SCHEDULE_STEP_MESSAGE_ADD,
  TROOP_SCHEDULE_STEP_MESSAGE_DISPLAY,
  TROOP_SCHEDULE_STEP_MESSAGE_EDIT,

  ADD_ACCUMULATOR_OVERRIDE_SCHEDULE_STATE,
  EDIT_ACCUMULATOR_OVERRIDE_SCHEDULE_STATE,
  DISPLAY_ACCUMULATOR_OVERRIDE_SCHEDULE_STATE,
  DOSAGE_FORM_LIST,
  DOSAGE_FORM,
  PACKAGING_CODES_LIST,
  COPY_MERGE_ADJUSTMENT_REASON_CODE_LIST,
  MEDICARE_LICS_SCHEDULE,
  MEDICARE_LICS_SCHEDULE_DETAIL,
  COPY_TROOP_SCHEDULE,
  COPY_ACCUMULATOR_OVERRIDE_SCHEDULE,
  ACCUMULATOR_OVERRIDE_SCHEDULE_NOTE,
  THIRD_PARTY_EXCEPTION,
  ROUTE_OF_ADMINISTRATION,
  ROUTE_OF_ADMINISTRATION_LIST,
  DEA_CLASS_LIST,
  CSR_FEDERAL_LEVEL,
  GPI_MSC_LIST,
  NDC_LIST,
  CSR_STATE_LEVEL,
  COST_SOURCE,
  COST_TYPE,
  MULTI_SOURCE_CODE_LIST,
  STATE_LIST,
  MAC_LIST,
  COPAY_SCHEDULE_STEP,
  SELECT_MESSAGE,
} = ROUTE_PATHS;

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path="/"
      element={
        <ModalProvider>
          <LoaderProvider>
          <App />
          </LoaderProvider>
        </ModalProvider>
      }
    >
      <Route path={PRICE_SCHEDULE} element={<PriceSchedule />} />
      <Route
        path={ADD_PRICE_SCHEDULE}
        element={<PriceScheduleForm mode={PRICE_SCHEDULE_MODES.ADD} />}
      />
      <Route
        path={EDIT_PRICE_SCHEDULE}
        element={<PriceScheduleForm mode={PRICE_SCHEDULE_MODES.EDIT} />}
      />
      <Route
        path={DISPLAY_PRICE_SCHEDULE}
        element={<PriceScheduleForm mode={PRICE_SCHEDULE_MODES.READ_ONLY} />}
      />
      <Route path={COPY_PRICE_SCHEDULE} element={<CopyPriceSchedule />} />
      <Route path={PRICE_SCHEDULE_NOTE} element={<PriceScheduleNote />} />

      <Route
        path={OUT_OF_POCKET_MAX_SCHEDULE}
        element={<OutOfPocketMaxSchedule />}
      />
      <Route
        path={OUT_OF_POCKET_MAX_SCHEDULE_STEPS}
        element={<OutOfPocketMaxScheduleSteps />}
      />
      <Route
        path={OUT_OF_POCKET_MAX_SCHEDULE_STEPS_DETAILS_EXT}
        element={<OutOfPocketMaxScheduleStepsDetailExt />}
      />
      <Route
        path={OUT_OF_POCKET_PATIENT_PAY_SCHEDULE}
        element={<OutofPocketPatientPaySchedule />}
      />
      <Route
        path={OUT_OF_POCKET_MAX_SCHEDULE_SUB_STEPS}
        element={<OutOfPocketSubStep />}
      />

      <Route
        path={ADD_OUT_OF_POCKET_MAX_SCHEDULE}
        element={<OutOfPocketForm mode={PRICE_SCHEDULE_MODES.ADD} />}
      />
      <Route
        path={EDIT_OUT_OF_POCKET_MAX_SCHEDULE}
        element={<OutOfPocketForm mode={PRICE_SCHEDULE_MODES.EDIT} />}
      />
      <Route
        path={DISPLAY_OUT_OF_POCKET_MAX_SCHEDULE}
        element={<OutOfPocketForm mode={PRICE_SCHEDULE_MODES.READ_ONLY} />}
      />

      <Route
        path={ADD_OUT_OF_POCKET_MAX_SCHEDULE_DETAIL}
        element={<OutOfPocketMaxDetailForm mode={PRICE_SCHEDULE_MODES.ADD} />}
      />
      <Route
        path={EDIT_OUT_OF_POCKET_MAX_SCHEDULE_DETAIL}
        element={<OutOfPocketMaxDetailForm mode={PRICE_SCHEDULE_MODES.EDIT} />}
      />
      <Route
        path={DISPLAY_OUT_OF_POCKET_MAX_SCHEDULE_DETAIL}
        element={
          <OutOfPocketMaxDetailForm mode={PRICE_SCHEDULE_MODES.READ_ONLY} />
        }
      />

      <Route
        path={ADD_OUT_OF_POCKET_MAX_SCHEDULE_STEPS_DETAILS_EXT}
        element={
          <OutOfPocketMaxScheduleStepsDetailExtForm
            mode={PRICE_SCHEDULE_MODES.ADD}
          />
        }
      />
      <Route
        path={EDIT_OUT_OF_POCKET_MAX_SCHEDULE_STEPS_DETAILS_EXT}
        element={
          <OutOfPocketMaxScheduleStepsDetailExtForm
            mode={PRICE_SCHEDULE_MODES.EDIT}
          />
        }
      />
      <Route
        path={DISPLAY_OUT_OF_POCKET_MAX_SCHEDULE_STEPS_DETAILS_EXT}
        element={
          <OutOfPocketMaxScheduleStepsDetailExtForm
            mode={PRICE_SCHEDULE_MODES.READ_ONLY}
          />
        }
      />

      <Route
        path={ADD_OUT_OF_POCKET_MAX_SCHEDULE_SUB_STEPS}
        element={<OutOfPocketSubStepForm mode={PRICE_SCHEDULE_MODES.ADD} />}
      />
      <Route
        path={EDIT_OUT_OF_POCKET_MAX_SCHEDULE_SUB_STEPS}
        element={<OutOfPocketSubStepForm mode={PRICE_SCHEDULE_MODES.EDIT} />}
      />
      <Route
        path={DISPLAY_OUT_OF_POCKET_MAX_SCHEDULE_SUB_STEPS}
        element={
          <OutOfPocketSubStepForm mode={PRICE_SCHEDULE_MODES.READ_ONLY} />
        }
      />

      <Route
        path={ADD_OUT_OF_POCKET_PATIENT_PAY_SCHEDULE}
        element={<OopPatientPaySchedulesForm mode={PRICE_SCHEDULE_MODES.ADD} />}
      />
      <Route
        path={EDIT_OUT_OF_POCKET_PATIENT_PAY_SCHEDULE}
        element={
          <OopPatientPaySchedulesForm mode={PRICE_SCHEDULE_MODES.EDIT} />
        }
      />
      <Route
        path={DISPLAY_OUT_OF_POCKET_PATIENT_PAY_SCHEDULE}
        element={
          <OopPatientPaySchedulesForm mode={PRICE_SCHEDULE_MODES.READ_ONLY} />
        }
      />

      <Route
        path={ADD_DEDUCTIBLE_SCHEDULE}
        element={<DeductibleScheduleForm mode={PRICE_SCHEDULE_MODES.ADD} />}
      />
      <Route
        path={EDIT_DEDUCTIBLE_SCHEDULE}
        element={<DeductibleScheduleForm mode={PRICE_SCHEDULE_MODES.EDIT} />}
      />
      <Route
        path={DISPLAY_DEDUCTIBLE_SCHEDULE}
        element={
          <DeductibleScheduleForm mode={PRICE_SCHEDULE_MODES.READ_ONLY} />
        }
      />
      <Route
        path={DEDUCTIBLE_SCHEDULE_STEPS}
        element={<DeductibleScheduleSteps />}
      />
      <Route path={DEDUCTIBLE_SCHEDULE} element={<DeductibleSchedule />} />
      <Route
        path={DEDUCTIBLE_SCHEDULE_NOTE}
        element={<DeductibleScheduleNote />}
      />

      <Route
        path={ACCUMULATOR_OVERRIDE_SCHEDULE_NOTE}
        element={<AccumulatorOverrideScheduleNote />}
      />

      <Route
        path={COPY_TROOP_SCHEDULE}
        element={<CopyTroopSchedule mode={PRICE_SCHEDULE_MODES.ADD} />}
      />
      <Route
        path={COPY_DEDUCTIBLE_SCHEDULE}
        element={<CopyDeductibleSchedule mode={PRICE_SCHEDULE_MODES.ADD} />}
      />
      <Route
        path={COPY_ACCUMULATION_CODE_LIST}
        element={
          <CopyMergeAccumulationCodeList mode={PRICE_SCHEDULE_MODES.ADD} />
        }
      />
      <Route
        path={COPY_OUT_OF_POCKET_MAX_SCHEDULE}
        element={<CopyOutOfPocketMaxSchedule mode={PRICE_SCHEDULE_MODES.ADD} />}
      />
      <Route
        path={COPY_MERGE_ADJUSTMENT_REASON_CODE_LIST}
        element={
          <CopyMergeAdjustmentReasonCodeList mode={PRICE_SCHEDULE_MODES.ADD} />
        }
      />
      <Route
        path={COPY_ACCUMULATOR_OVERRIDE_SCHEDULE}
        element={
          <CopyAccumulatorOverrideSchedule mode={PRICE_SCHEDULE_MODES.ADD} />
        }
      />

      <Route
        path={COPY_BENEFIT_MAX_DRUG_STATUS_SCHEDULE}
        element={
          <CopyBenefitMaxDrugStatusSchedule mode={PRICE_SCHEDULE_MODES.ADD} />
        }
      />
      <Route
        path={COPY_BENEFIT_MAX_SCHEDULE}
        element={<CopyBenefitMaxSchedule mode={PRICE_SCHEDULE_MODES.ADD} />}
      />

      <Route
        path={ADD_DEDUCTIBLE_PATIENT_PAY_SCHEDULE}
        element={
          <DeductiblePatientPayScheduleForm mode={PRICE_SCHEDULE_MODES.ADD} />
        }
      />
      <Route
        path={EDIT_DEDUCTIBLE_PATIENT_PAY_SCHEDULE}
        element={
          <DeductiblePatientPayScheduleForm mode={PRICE_SCHEDULE_MODES.EDIT} />
        }
      />
      <Route
        path={DISPLAY_DEDUCTIBLE_PATIENT_PAY_SCHEDULE}
        element={
          <DeductiblePatientPayScheduleForm
            mode={PRICE_SCHEDULE_MODES.READ_ONLY}
          />
        }
      />
      <Route
        path={ADD_DEDUCTIBLE_SCHEDULE_STEP}
        element={
          <DeductibleScheduleStepsForm mode={PRICE_SCHEDULE_MODES.ADD} />
        }
      />
      <Route
        path={EDIT_DEDUCTIBLE_SCHEDULE_STEP}
        element={
          <DeductibleScheduleStepsForm mode={PRICE_SCHEDULE_MODES.EDIT} />
        }
      />
      <Route
        path={DISPLAY_DEDUCTIBLE_SCHEDULE_STEP}
        element={
          <DeductibleScheduleStepsForm mode={PRICE_SCHEDULE_MODES.READ_ONLY} />
        }
      />
      <Route
        path={DEDUCTIBLE_SCHEDULE_STEP_DETAIL_EXTENSION}
        element={
          <DeductibleScheduleStepDetailExtensionForm
            mode={PRICE_SCHEDULE_MODES.ADD}
          />
        }
      />
      <Route
        path={OUT_OF_POCKET_MAX_SCHEDULE_NOTE}
        element={<OutOfPocketMaxScheduleNote />}
      />

      <Route
        path={PATIENT_PAY_SCHEDULES}
        element={<DeductibleScheduleStepPatientPaySchedules />}
      />
      <Route
        path={BENEFIT_MAX_DRUG_STATUS_SCHEDULE}
        element={<BenefitMaxDrugStatusSchedule />}
      />
      <Route
        path={BENEFIT_MAX_DRUG_STATUS_SCHEDULE}
        element={<BenefitMaxDrugStatusSchedule />}
      />
      <Route
        path={ADD_BENEFIT_MAX_DRUG_STATUS_SCHEDULE}
        element={
          <BenefitMaxDrugStatusScheduleForm mode={PRICE_SCHEDULE_MODES.ADD} />
        }
      />
      <Route
        path={EDIT_BENEFIT_MAX_DRUG_STATUS_SCHEDULE}
        element={
          <BenefitMaxDrugStatusScheduleForm mode={PRICE_SCHEDULE_MODES.EDIT} />
        }
      />
      <Route
        path={DISPLAY_BENEFIT_MAX_DRUG_STATUS_SCHEDULE}
        element={
          <BenefitMaxDrugStatusScheduleForm
            mode={PRICE_SCHEDULE_MODES.READ_ONLY}
          />
        }
      />

      <Route
        path={BENEFIT_MAX_SCHEDULE_ADD}
        element={
          <BenefitMaxScheduleForm key="add" mode={PRICE_SCHEDULE_MODES.ADD} />
        }
      />
      <Route
        path={BENEFIT_MAX_SCHEDULE_EDIT}
        element={
          <BenefitMaxScheduleForm key="edit" mode={PRICE_SCHEDULE_MODES.EDIT} />
        }
      />
      <Route
        path={BENEFIT_MAX_SCHEDULE_DISPLAY}
        element={
          <BenefitMaxScheduleForm
            key="display"
            mode={PRICE_SCHEDULE_MODES.READ_ONLY}
          />
        }
      />

      <Route
        path={BENEFIT_MAX_STEP_SCHEDULE_SEARCH}
        element={<BenefitMaxScheduleSteps />}
      />

      <Route
        path={BENEFIT_MAX_STEP_SCHEDULE_ADD}
        element={<BenefitMaxStepScheduleForm mode={PRICE_SCHEDULE_MODES.ADD} />}
      />
      <Route
        path={BENEFIT_MAX_STEP_SCHEDULE_EDIT}
        element={
          <BenefitMaxStepScheduleForm mode={PRICE_SCHEDULE_MODES.EDIT} />
        }
      />
      <Route
        path={BENEFIT_MAX_STEP_SCHEDULE_DISPLAY}
        element={
          <BenefitMaxStepScheduleForm mode={PRICE_SCHEDULE_MODES.READ_ONLY} />
        }
      />

      <Route
        path={BENEFIT_ALT_COPAY_FORM_EDIT}
        element={
          <BenefitMaximumStepAlternateCopaysForm
            mode={PRICE_SCHEDULE_MODES.ADD}
          />
        }
      />
      <Route path={BENEFIT_MAX_SCHEDULE} element={<BenefitMaxSchedule />} />

      <Route
        path={BENEFIT_MAX_SCHEDULE_NOTE}
        element={<BenefitMaxScheduleNote />}
      />

      <Route
        path={ALTERNATE_COPPAY_OVERRIDE}
        element={<AlternateCopayPSCOverrides />}
      />

      <Route
        path={ALTERNATE_COPAY_OVERRIDE_ADD}
        element={
          <AlternateCopayPscOverrideForm mode={PRICE_SCHEDULE_MODES.ADD} />
        }
      />
      <Route
        path={ALTERNATE_COPAY_OVERRIDE_EDIT}
        element={
          <AlternateCopayPscOverrideForm mode={PRICE_SCHEDULE_MODES.EDIT} />
        }
      />
      <Route
        path={ALTERNATE_COPAY_OVERRIDE_DISPLAY}
        element={
          <AlternateCopayPscOverrideForm
            mode={PRICE_SCHEDULE_MODES.READ_ONLY}
          />
        }
      />
      <Route path={DRUG_STATUS_SCHEDULE} element={<DrugStatusSchedule />} />
      <Route
        path={ADD_DRUG_STATUS_SCHEDULE}
        element={<DrugStatusForm mode={PRICE_SCHEDULE_MODES.ADD} />}
      />
      <Route
        path={EDIT_DRUG_STATUS_SCHEDULE}
        element={<DrugStatusForm mode={PRICE_SCHEDULE_MODES.EDIT} />}
      />
      <Route
        path={DISPLAY_DRUG_STATUS_SCHEDULE}
        element={<DrugStatusForm mode={PRICE_SCHEDULE_MODES.READ_ONLY} />}
      />
      <Route path={ACCUMULATION_CODE} element={<AccumulationCode />} />
      <Route path={ACCUMULATION_CODE_EXTERNAL} element={<AccumulationCode />} />
      <Route
        path={ADD_ACCUMULATOR_OVERRIDE_SCHEDULE}
        element={
          <AccumulatorOverrideScheduleForm mode={PRICE_SCHEDULE_MODES.ADD} />
        }
      />
      <Route
        path={EDIT_ACCUMULATOR_OVERRIDE_SCHEDULE}
        element={
          <AccumulatorOverrideScheduleForm mode={PRICE_SCHEDULE_MODES.EDIT} />
        }
      />
      <Route
        path={DISPLAY_ACCUMULATOR_OVERRIDE_SCHEDULE}
        element={
          <AccumulatorOverrideScheduleForm
            mode={PRICE_SCHEDULE_MODES.READ_ONLY}
          />
        }
      />
      <Route
        path={ADD_ACCUMULATOR_OVERRIDE_SCHEDULE_CRITERIA}
        element={
          <AccumulatorOverrideScheduleCriteriaForm
            key="add"
            mode={PRICE_SCHEDULE_MODES.ADD}
          />
        }
      />
      <Route
        path={EDIT_ACCUMULATOR_OVERRIDE_SCHEDULE_CRITRIA}
        element={
          <AccumulatorOverrideScheduleCriteriaForm
            key="edit"
            mode={PRICE_SCHEDULE_MODES.EDIT}
          />
        }
      />
      <Route
        path={DISPLAY_ACCUMULATOR_OVERRIDE_SCHEDULE_CRITRIA}
        element={
          <AccumulatorOverrideScheduleCriteriaForm
            key="display"
            mode={PRICE_SCHEDULE_MODES.READ_ONLY}
          />
        }
      />
      <Route
        path={ADD_ACCUMULATOR_OVERRIDE_SCHEDULE_STATE}
        element={
          <AccumulatorOverrideStateScheduleForm
            key="add"
            mode={PRICE_SCHEDULE_MODES.ADD}
          />
        }
      />
      <Route
        path={EDIT_ACCUMULATOR_OVERRIDE_SCHEDULE_STATE}
        element={
          <AccumulatorOverrideStateScheduleForm
            key="edit"
            mode={PRICE_SCHEDULE_MODES.EDIT}
          />
        }
      />
      <Route
        path={DISPLAY_ACCUMULATOR_OVERRIDE_SCHEDULE_STATE}
        element={
          <AccumulatorOverrideStateScheduleForm
            key="display"
            mode={PRICE_SCHEDULE_MODES.READ_ONLY}
          />
        }
      />

      <Route
        path={ACCUMULATION_CODE_ADD}
        element={<AccumulationCodeForm mode={PRICE_SCHEDULE_MODES.ADD} />}
      />

      <Route
        path={ACCUMULATION_CODE_DISPLAY}
        element={<AccumulationCodeForm mode={PRICE_SCHEDULE_MODES.READ_ONLY} />}
      />

      <Route
        path={ACCUMULATION_CODE_EDIT}
        element={<AccumulationCodeForm mode={PRICE_SCHEDULE_MODES.EDIT} />}
      />
      <Route
        path={ACCUMULATION_CODE_LIST_ADD}
        element={<AccumulationCodeListForm mode={PRICE_SCHEDULE_MODES.ADD} />}
      />
      <Route
        path={ACCUMULATION_CODE_LIST_EDIT}
        element={<AccumulationCodeListForm mode={PRICE_SCHEDULE_MODES.EDIT} />}
      />
      <Route
        path={ACCUMULATION_CODE_LIST_DISPLAY}
        element={
          <AccumulationCodeListForm mode={PRICE_SCHEDULE_MODES.READ_ONLY} />
        }
      />
      <Route path={ACCUMULATION_CODE_LIST} element={<AccumulationCodeList />} />
      <Route
        path={ACCUMULATION_CODE_LIST_CODES}
        element={<AccumulationCodeListAl2 />}
      />
      <Route
        path={ADJUSTMENT_REASON_CODE_LIST}
        element={<AdjustmentReasonCodeList />}
      />
      <Route
        path={ADJUSTMENT_REASON_CODE_LIST_ADD}
        element={
          <AdjustmentReasonCodeListForm mode={PRICE_SCHEDULE_MODES.ADD} />
        }
      />
      <Route
        path={ADJUSTMENT_REASON_CODE_LIST_EDIT}
        element={
          <AdjustmentReasonCodeListForm mode={PRICE_SCHEDULE_MODES.EDIT} />
        }
      />
      <Route
        path={ADJUSTMENT_REASON_CODE_LIST_DISPLAY}
        element={
          <AdjustmentReasonCodeListForm mode={PRICE_SCHEDULE_MODES.READ_ONLY} />
        }
      />

      <Route path={ADJUSTMENT_REASON_CODE} element={<AdjustmentReasonCode />} />

      <Route
        path={ADJUSTMENT_REASON_CODE_ADD}
        element={
          <AdjustmentReasonForm key="add" mode={PRICE_SCHEDULE_MODES.ADD} />
        }
      />

      <Route
        path={ADJUSTMENT_REASON_CODE_DISPLAY}
        element={
          <AdjustmentReasonForm
            key="display"
            mode={PRICE_SCHEDULE_MODES.READ_ONLY}
          />
        }
      />
      <Route
        path={ADJUSTMENT_REASON_CODE_EDIT}
        element={
          <AdjustmentReasonForm key="edit" mode={PRICE_SCHEDULE_MODES.EDIT} />
        }
      />
      <Route
        path={ACCUMULATOR_OVERRIDE_SCHEDULE}
        element={<AccumulatorOverrideSchedule />}
      />
      <Route
        path={ACCUMULATOR_OVERRIDE_SCHEDULE_CRITERIA}
        element={<AccumulatorOverrideScheduleCriteria />}
      />
      <Route
        path={CODES_IN_ADJUSTMENT_REASON_CODE_LIST}
        element={<CodesInAdjustmentReasonCodeList />}
      />
      <Route
        path={MEDICARE_STANDARD_TROOP_SCHEDULE_STEPS}
        element={<StandardTroopScheduleSteps />}
      />
      <Route
        path={MEDICARE_STANDARD_TROOP_SCHEDULE}
        element={<StandardTroopSchedule />}
      />
      <Route
        path={MEDICARE_STANDARD_TROOP_SCHEDULE_STEPS_DETAIL}
        element={
          <StandardTrOOPScheduleStepDetailForm
            mode={PRICE_SCHEDULE_MODES.READ_ONLY}
          />
        }
      />
      <Route
        path={MEDICARE_STANDARD_TROOP_SCHEDULE_STEPS}
        element={<StandardTroopScheduleSteps />}
      />
      <Route path={PLAN_OVERRIDE} element={<PlanOverride />} />
      <Route
        path={ACCUMULATOR_OVERRIDE_SCHEDULE_STATE}
        element={<AccumulatorOverrideStateSchedule />}
      />
      <Route path={TROOP_SCHEDULE} element={<TrOOPSchedule />} />

      <Route path={TROOP_SCHEDULE_STEP} element={<TroopScheduleStep />} />

      <Route
        path={TROOP_SCHEDULE_EDIT}
        element={
          <TroopScheduleForm key="edit" mode={PRICE_SCHEDULE_MODES.EDIT} />
        }
      />
      <Route
        path={TROOP_SCHEDULE_DISPLAY}
        element={
          <TroopScheduleForm
            key="display"
            mode={PRICE_SCHEDULE_MODES.READ_ONLY}
          />
        }
      />
      <Route
        path={TROOP_SCHEDULE_ADD}
        element={
          <TroopScheduleForm key="add" mode={PRICE_SCHEDULE_MODES.ADD} />
        }
      />
      <Route path={MEDICARE_LICS_SCHEDULE} element={<LicsSchedule />} />
      <Route
        path={MEDICARE_LICS_SCHEDULE_DETAIL}
        element={<LicsScheduleDetail />}
      />

      <Route path={DOSAGE_FORM_LIST} element={<DosageFormList />} />

      <Route path={DOSAGE_FORM} element={<DosageForm />} />

      <Route path={PACKAGING_CODES_LIST} element={<PackagingCodesList />} />

      <Route
        path={TROOP_SCHEDULE_STEP_ADD}
        element={<TroopScheduleStepForm mode={PRICE_SCHEDULE_MODES.ADD} />}
      />
      <Route
        path={TROOP_SCHEDULE_STEP_DISPLAY}
        element={
          <TroopScheduleStepForm mode={PRICE_SCHEDULE_MODES.READ_ONLY} />
        }
      />
      <Route
        path={TROOP_SCHEDULE_STEP_EDIT}
        element={<TroopScheduleStepForm mode={PRICE_SCHEDULE_MODES.EDIT} />}
      />
      <Route
        path={TROOP_SCHEDULE_STEP_MESSAGE}
        element={<TrOOPScheduleStepMessage />}
      />

      <Route
        path={TROOP_SCHEDULE_STEP_MESSAGE_ADD}
        element={
          <TroopScheduleStepMessageForm mode={PRICE_SCHEDULE_MODES.ADD} />
        }
      />
      <Route
        path={TROOP_SCHEDULE_STEP_MESSAGE_DISPLAY}
        element={
          <TroopScheduleStepMessageForm mode={PRICE_SCHEDULE_MODES.READ_ONLY} />
        }
      />
      <Route
        path={TROOP_SCHEDULE_STEP_MESSAGE_EDIT}
        element={
          <TroopScheduleStepMessageForm mode={PRICE_SCHEDULE_MODES.EDIT} />
        }
      />
      <Route path={THIRD_PARTY_EXCEPTION} element={<ThirdPartyException />} />
      <Route
        path={ROUTE_OF_ADMINISTRATION}
        element={<RouteOfAdministration />}
      />
      <Route
        path={ROUTE_OF_ADMINISTRATION_LIST}
        element={<RouteOfAdministrationList />}
      />
      <Route path={DEA_CLASS_LIST} element={<DeaClassList />} />
      <Route path={CSR_FEDERAL_LEVEL} element={<CsrFederalLevel />} />
      <Route path={GPI_MSC_LIST} element={<GpiMscList />} />
      <Route path={NDC_LIST} element={<NdcList />} />
      <Route path={CSR_STATE_LEVEL} element={<CsrStateLevel />} />
      <Route path={COST_SOURCE} element={<CostSource />} />
      <Route path={COST_TYPE} element={<CostType />} />
      <Route path={MULTI_SOURCE_CODE_LIST} element={<MultiSourceCodeList />} />
      <Route path={STATE_LIST} element={<StateList />} />
      <Route path={MAC_LIST} element={<MacList />} />
      <Route path={COPAY_SCHEDULE_STEP} element={<CopayScheduleStep />} />
      <Route path={SELECT_MESSAGE} element={<SelectMessage />} />
    </Route>
  )
);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <RBACProvider>
        <PrimeReactProvider>
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </PrimeReactProvider>
      </RBACProvider>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();